import { render, staticRenderFns } from "./docking.vue?vue&type=template&id=30a0aeef&scoped=true"
import script from "./docking.vue?vue&type=script&lang=js"
export * from "./docking.vue?vue&type=script&lang=js"
import style0 from "./docking.vue?vue&type=style&index=0&id=30a0aeef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0aeef",
  null
  
)

export default component.exports